<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Merchandise Hierarchy Id"
            prepend-icon="mdi-magnify"
            v-model.number="merchandiseHierarchyId"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Merchandise Hierarchy Name"
            v-model="merchandiseHierarchyName"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn v-if="isAdminUser" tile color="blue lighten-4" v-bind:to="{ path: 'newMerchandiseHierarchy' }">
            <v-icon>mdi-plus</v-icon>
            Add new merchandise hierarchy
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            v-if="isAdminUser && isSyncWithProdFlag()"
            tile color="blue lighten-4"
            @click="synchronizeWithProduction">
            <v-icon>mdi-sync</v-icon>
            Synchronize with production
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">Comment</th>
              <th scope="col">Scope</th>
              <th scope="col">Item Type</th>
              <th scope="col">NotNormallyStockedFlag</th>
              <th scope="col">Item ID</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="merchandiseHierarchy in merchandiseHierarchies" v-if="isMerchandiseHierarchyFiltered(merchandiseHierarchy)">
              <td>{{ merchandiseHierarchy.id }}</td>
              <td>{{ merchandiseHierarchy.name }}</td>
              <td>{{ merchandiseHierarchy.comment }}</td>
              <td>{{ merchandiseHierarchy.scope }}</td>
              <td>{{ merchandiseHierarchy.expectedItemType }}</td>
              <td>{{ merchandiseHierarchy.expectedNotNormallyStockedFlag }}</td>
              <td>{{ merchandiseHierarchy.expectedItemID }}</td>
              <td>
                <router-link
                  v-if="isAdminUser"
                  class="btn btn-edit"
                  v-bind:to="{ path: 'editMerchandiseHierarchy', query: { id: merchandiseHierarchy.id } }"
                >
                  <v-icon>mdi-pencil</v-icon>
                  <span class="editspan">Edit</span>
                </router-link>
              </td>
              <td>
                <button
                  v-if="isAdminUser"
                  class="btn btn-delete"
                  @click="deleteMerchandiseHierarchy(merchandiseHierarchy.id)"
                >
                  <v-icon>mdi-delete</v-icon>
                  <span class="editspan">Delete</span>
                </button>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";

export default {
  name: "MerchandiseHierarchies",
  data() {
    return {
      merchandiseHierarchies: [],
      merchandiseHierarchyName: "",
      merchandiseHierarchyId: ""
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/itemCategories`)
      .then((response) => {
        this.merchandiseHierarchies = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    isMerchandiseHierarchyFiltered: function (merchandiseHierarchy) {
      return (
        (this.merchandiseHierarchyId === null ||
          this.merchandiseHierarchyId === "" ||
          this.merchandiseHierarchyId === merchandiseHierarchy.id) &&
        (this.merchandiseHierarchyName === null ||
          this.merchandiseHierarchyName === "" ||
          merchandiseHierarchy.name.includes(this.merchandiseHierarchyName))
      );
    },
    deleteMerchandiseHierarchy: async function (idMerchandiseHierarchy) {
      if (confirm('Are you sure you want to delete the MerchandiseHierarchy with the id ?' + idMerchandiseHierarchy)) {
        await httpClient.delete(`${parameters.posdataRefUrl}/itemCategory/` + idMerchandiseHierarchy);
        window.location.reload()
      }
    },
    synchronizeWithProduction: async function () {
      try {
        if (!confirm('Are you sure you want to synchronize all merchandise hierarchies with production ?')) {
          return;
        }

        await httpClient.post(
          `${parameters.posdataRefUrl}/itemCategories/synchronize-with-production`
        );

        await this.reloadMerchandiseHierarchies();
        await this.$alert("Merchandise hierarchies have been synchronized with production");

      } catch (error) {
        alert('Error synchronizing merchandise hierarchies');
        throw error;
      }
    },
    reloadMerchandiseHierarchies: async function () {
      return await httpClient
        .get(`${parameters.posdataRefUrl}/itemCategories`)
        .then((response) => {
          this.merchandiseHierarchies = response.data;
        })
        .catch((error) => {
          throw error;
        });
    },
    isSyncWithProdFlag: function (){
      return parameters.syncWithProdFlag === true;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/merchandiseHierarchies/MerchandiseHierarchies.vue